import isEqual from 'lodash.isequal';
export var getChangedMenuConfig = function (_a) {
    var prevFlattenMenuList = _a.prevFlattenMenuList, newFlattenMenuList = _a.newFlattenMenuList;
    return prevFlattenMenuList.reduce(function (acc, menuListItem, index) {
        if (!acc.areEqual) {
            return acc;
        }
        var isEqualMenuItems = isEqual(menuListItem, newFlattenMenuList[index]);
        if (!isEqualMenuItems) {
            return {
                config: menuListItem.config,
                areEqual: false,
                name: menuListItem.name,
            };
        }
        return acc;
    }, {
        config: null,
        areEqual: true,
        name: '',
    });
};
